import React from 'react';

import { IconProps } from '../types';

function MouseWheelSolidIcon({ className, id }: IconProps) {
  return (
    <svg
      id={id}
      xmlns="http://www.w3.org/2000/svg"
      className={className || 'h-5 w-5'}
      fill="currentColor"
      viewBox="0 0 20 20"
    >
      <path
        fillRule="evenodd"
        d="M10 19c-2.8 0-5-2.2-5-5V6c0-2.8 2.2-5 5-5s5 2.2 5 5v8c0 2.8-2.2 5-5 5zm4-9c0-.6-.4-1-1-1H7c-.6 0-1 .4-1 1s.4 1 1 1h6c.6 0 1-.4 1-1zm0 3c0-.6-.4-1-1-1H7c-.6 0-1 .4-1 1s.4 1 1 1h6c.6 0 1-.4 1-1zm-1 3c0-.6-.4-1-1-1H8c-.6 0-1 .4-1 1s.4 1 1 1h4c.6 0 1-.4 1-1zm1-9c0-.6-.4-1-1-1H7c-.6 0-1 .4-1 1s.4 1 1 1h6c.6 0 1-.4 1-1zm-1-3c0-.6-.4-1-1-1H8c-.6 0-1 .4-1 1s.4 1 1 1h4c.6 0 1-.4 1-1z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default MouseWheelSolidIcon;
